// import { plkPrimitives } from './primitives';

export const plkComponentTokens = {
  button: {
    // 'background-button-hover-reversed': bkPrimitives.colors.whiteOpacity[10],
    // 'background-button-primary-default': bkPrimitives.colors.fieryRed,
    // 'background-button-primary-default-reversed': bkPrimitives.colors.white,
    // 'background-button-primary-hover': bkPrimitives.colors.fieryRedDarken10,
    // 'background-button-secondary-hover': bkPrimitives.colors.fieryRedOpacity10,
    // 'border-color-button-secondary': bkPrimitives.colors.fieryRed,
    // 'border-color-button-secondary-reversed': bkPrimitives.colors.white,
    // 'border-width-button-secondary': bkPrimitives.spacing.px,
    // 'box-shadow-button': `0 0 0 4px ${bkPrimitives.colors.blackOpacity[10]}`,
    // 'height-button-large': bkPrimitives.spacing.spacing9,
    // 'height-button-small': bkPrimitives.spacing.spacing7,
    // 'icon-button-primary': bkPrimitives.colors.white,
    // 'icon-button-primary-reversed': bkPrimitives.colors.bbqBrown,
    // 'icon-button-reversed': bkPrimitives.colors.white,
    // 'icon-button-secondary': bkPrimitives.colors.bbqBrown,
    // 'icon-button-tertiary-default': bkPrimitives.colors.bbqBrown,
    // 'icon-button-tertiary-hover': bkPrimitives.colors.bbqBrown,
    // 'padding-button-icon-end': `${bkPrimitives.spacing.spacing0} ${bkPrimitives.spacing.spacing2} ${bkPrimitives.spacing.spacing0} ${bkPrimitives.spacing.spacing4}`,
    // 'padding-button-icon-start': `${bkPrimitives.spacing.spacing0} ${bkPrimitives.spacing.spacing4} ${bkPrimitives.spacing.spacing0} ${bkPrimitives.spacing.spacing2}`,
    // 'padding-button-large': `${bkPrimitives.spacing.spacing0} ${bkPrimitives.spacing.spacing5}`,
    // 'padding-button-small': `${bkPrimitives.spacing.spacing0} ${bkPrimitives.spacing.spacing4}`,
    // 'text-button-primary': bkPrimitives.colors.white,
    // 'text-button-primary-reversed': bkPrimitives.colors.bbqBrown,
    // 'text-button-reversed': bkPrimitives.colors.white,
    // 'text-button-secondary': bkPrimitives.colors.bbqBrown,
    // 'text-button-tertiary-default': bkPrimitives.colors.bbqBrown,
    // 'text-button-tertiary-hover': bkPrimitives.colors.bbqBrown,
    // // todo: migrate deprecated text styles to primitives and tokens
    // 'text-style-button-large': 'var(--font-headerThree)',
    // // todo: migrate deprecated text styles to primitives and tokens
    // // 'text-style-button-small': bkPrimitives.bk.$headerFour,
    // 'border-radius-button': '100%',
  },
} as const;
